import { AppPage } from 'common/Layout';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';
import { MaxLessonsPerDayTable } from 'widgets/max-lessons-per-day-table';

export const MaxLessonsPerDayPage = () => {
  const breadcrumbs = [
    homeBreadcrumbItem,
    {
      title: 'Конфигурации максимумов уроков в день',
      url: '',
    },
  ];

  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
      }}
      documentTitle="Конфигурации максимумов уроков в день"
    >
      <MaxLessonsPerDayTable />
    </AppPage>
  );
};
